/**
 * 模板市场-盒子容器
 * @author VenDream
 * @since 17/11/9
 */

import { connect } from 'react-redux';
import StoreTplBox from 'components/store-tpl-box/store-tpl-box';

import { showModal } from 'actions/modal';
import { setTplCollectionStatus } from 'actions/tpls';

const mapStateToProps = (state, ownProps) => {
  const { id, category } = ownProps;
  const { userInfo, tpls, storeFilters } = state;
  return {
    user: userInfo,
    filters: storeFilters.submitFilters,
    tplCornerLabelObj: storeFilters.tplCornerLabelObj,
    category,
    tpl: tpls.byId[id],
  };
};

const mapDispatchToProps = dispatch => ({
  showModal: opts => dispatch(showModal(opts)),
  setTplCollectionStatus: (userId, organizeId, tplId, isCollectionTpl) =>
    dispatch(
      setTplCollectionStatus(userId, organizeId, tplId, isCollectionTpl)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreTplBox);
